<ion-header>
    <ion-toolbar mode="ios">
        <ion-title>{{'ComingSoon' | translation}}</ion-title>
        <ion-buttons slot="end">
            <ion-button fill="clear" (click)="dismiss()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <h4 style="text-align: center;">{{'ComingSoon' | translation}}</h4>
</ion-content>